import styled from 'styled-components/macro';
import React from 'react';
import InputBase from '../../../components/form/InputBase';
import useTranslations from '../../../hooks/useTranslations';
import { SimpleFlexContainer } from '../../../components/layouts/ng-layouts/Containers';

const FlexValues = {
  option: 1,
  value: 1
};

const TitleContainer = styled(SimpleFlexContainer)`
  gap: 0.8rem;
  padding-left: 0.8rem;
  h3[data-id='option'] {
    flex: ${FlexValues.option};
  }

  h3[data-id='value'] {
    flex: ${FlexValues.value};
  }
`;

const List = styled(SimpleFlexContainer)``;

const ScoringContainer = styled(SimpleFlexContainer)`
  margin: 0.8rem 0;
  gap: 0.8rem;
  padding-left: 0.8rem;
`;

const TextWrapper = styled.div`
  flex: ${FlexValues.option};
`;

const InputWrapper = styled.div`
  flex: ${FlexValues.value};
`;

const ScoringPanelView = props => {
  const t = useTranslations();

  return (
    <SimpleFlexContainer>
      <TitleContainer $row>
        <h3 data-id="option">
          {t('form-builder.drawer.scoring_options.title')}
        </h3>
        <h3 data-id="value">{t('form-builder.drawer.scoring_value.title')}</h3>
      </TitleContainer>
      <List>
        {props.fieldOptions.map((option, index) => (
          <ScoringContainer $row>
            <TextWrapper>
              <p>{option}</p>
            </TextWrapper>
            <InputWrapper>
              <InputBase
                value={
                  props.data[index] && props.data[index].value === 0
                    ? 0
                    : (props.data[index] && props.data[index].value) || ''
                }
                onChange={event => props.onScoringValuesSaved(event, option)}
                onBlur={props.onScoringValuesBlur}
                inputProps={{ 'data-lpignore': true }}
              />
            </InputWrapper>
          </ScoringContainer>
        ))}
      </List>
    </SimpleFlexContainer>
  );
};

export default ScoringPanelView;
